import namespace from '@/store/namespace'
export default namespace('DetalleInclusionExclusion',{
    getters:[
        'GetlstInclusionExclusion',
        'GetdatosInclusionExclusionNet',
        'GetdatosInclusionExclusionBorrador',
        'GetdatosInclusionExclusionPromocion'
    ],
    actions:[
        'RegistrarInclusionExclusion',
        'ModificarInclusionExclusion',
        'ObtenerInclusionExclusion',
        'EliminarInclusionExclusion',
        'EnviarInclusionExclusionSolicitud',
        'ObtenerInclusionExclusionNet',
        'ObtenerInclusionExclusionxDetalleInclusionExclusionId',
        'ObtenerInclusionExclusionSolicitudesNet',
        'ObtenerInclusionExclusionBorrador',
        'ObtenerInclusionExclusionPromocionesNet'
    ],
    mutations:[
        'SetlstInclusionExclusion',
        'SetdatosInclusionExclusionNet',
        'SetdatosInclusionExclusionBorrador',
        'SetdatosInclusionExclusionPromocion'
    ]
})
